import React from "react";

const LkMenuMobile = (props) => {
    return(
        <div className="flex items-center justify-between">
            <div onClick={() => window.location.replace('/')}>
                <img src={props.data.menuTop.logo1} />
            </div>
            <div className="flex items-center gap-[10px]">
                <div>
                    <a href="#" >
                        <img src={props.data.MenuProfile.profile.image}/>
                    </a>
                </div>
                <div>
                    <button className="rounded-[43px] p-[7px]" style={{
                        backgroundColor: '#E4E6E9'
                    }}
                    onClick={props.ClickNavMobOpen}>
                        {
                            !props.navMobOpen ?
                                <img src="/img/lk/lkNav/navMobBtn.svg" /> :
                                <img src="/img/lk/lkNav/navMobBtn1.svg" />
                        }
                        
                    </button>
                </div>
            </div>
        </div>
    )
}

export default LkMenuMobile;
